import { routerMiddleware } from 'react-router-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import { createEpicMiddleware } from "redux-observable"

import thunk from "redux-thunk"
import multi from "redux-multi"
import createHistory from 'history/createBrowserHistory'
import reducers from './reducers'
import epics from "./epics"

const history = createHistory()
const historyMiddleware = routerMiddleware(history);
const epicMiddleware = createEpicMiddleware(epics);
const middleware = compose(applyMiddleware(multi, thunk, epicMiddleware, historyMiddleware));
const store = createStore(reducers, middleware);

export { store };
export { history };






// WEBPACK FOOTER //
// ./src/store.js